import React, { useEffect, useState } from "react";
import { get } from "lodash";
import useAuth from "src/hooks/useAuth";
import { Box, Button, Dialog } from "@mui/material";
import { MuiButtonStyle } from "src/theme/buttonStyle";
import { acceptInvite, rejectInvite } from "src/services/setting";
import useToast from "src/hooks/useToast";
import { useSelector } from "react-redux";

const Invited_Journey = () => {
  const { user, refreshUserDetails, logout } = useAuth();
  const TOAST = useToast();
  const [showInvitationPopup, setShowInvitationPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {entireStrapiData:{WebappHomepageV22}} = useSelector((state)=> state.strapi);

  const acceptInvitationHandler = async() => {
    try{
        setIsLoading(true);
        await acceptInvite();
        setIsLoading(false);
        TOAST.success("Invitation accepted successfully");
        setShowInvitationPopup(false);
        const userDetails = await refreshUserDetails();
        console.log(userDetails?.user?.user_role?.name, 'isLoggingIn')
        if(userDetails?.user?.user_role?.name.toUpperCase() === "APP_USER"){
          TOAST.error(`${WebappHomepageV22?.WebappHomepageV22?.loggingOut || "You don't have the permission to Login. Logging out!"}`);
          logout();
        }

    }catch(e){
      TOAST.error(e.message);
        setIsLoading(false);
        // TOAST.error("Unable to process your request");
    }
  };

  const rejectInvitationHandler = async() => {
    const email=get(user,"user.email");
    if(!email) return;
    try{
        setIsLoading(true);
        await rejectInvite(email);
        setIsLoading(false);
        TOAST.success("Invitation Rejected successfully");
        setShowInvitationPopup(false);
        refreshUserDetails();
    }catch(error){
        setIsLoading(false);
        TOAST.error("Unable to process your request");
    }
  }
  useEffect(() => {
    if (user?.enterpriseUserMerge) {
      setShowInvitationPopup(true);
    } else {
      setShowInvitationPopup(false);
    }
  }, [user]);
  return (
    <Dialog
      onClose={() => setShowInvitationPopup(false)}
      open={showInvitationPopup}
    >
      <Box
        sx={{
          width: "600px",
          height: "430px",
          background: "#F9F9F9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "36px",
        }}
      >
        <Box
          sx={{
            width: "520px",
            height: "222px",
            background: "#fff",
            border: "0.5px solid #EEEEEE",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
          }}
        >
          <img
            src="/images/home/system.svg"
            alt=""
            width="24px"
            height="24px"
          />
          <Box>You have been invited to join an enterprise</Box>
          <Box sx={{ fontSize: "14px", fontWeight: "bold" }}>
            
          </Box>
          <Button
            sx={{
              ...MuiButtonStyle.button,
              border: "1px solid #EEEEEE",
              borderRadius: "50px",
              width: "360px",
              height: "54px",
              mt: "18px",
            }}
            onClick={acceptInvitationHandler}
            disabled={isLoading}
          >
            Accept Invitation
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            fontSize: "10px",
          }}
        >
          <span style={{ border: "1px solid #EEEEEE", width: "42px" }}></span>
          OR
          <span style={{ border: "1px solid #EEEEEE", width: "42px" }}></span>
        </Box>
        <Button
          sx={{
            ...MuiButtonStyle.grayColorButton,
            border: "1px solid #EEEEEE",
            borderRadius: "50px",
            width: "360px",
          }}
          onClick={rejectInvitationHandler}
          disabled={isLoading}
        >
          Continue as personal user
        </Button>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "5px",
          right: "5px",
          background: "#EEEEEE",
          width: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          cursor: "pointer",
        }}
        onClick={() => setShowInvitationPopup(false)}
      >
        <img src="/images/cancel.svg" alt="" width="12px" height="12px" />
      </Box>
    </Dialog>
  );
};

export default Invited_Journey;
